<div class="toolbar w-full px-gutter" fxLayout="row" fxLayoutAlign="start center" vexContainer>
  <button (click)="openSidenav()" [fxHide]="!mobileQuery" mat-icon-button type="button">
    <mat-icon [icIcon]="icMenu"></mat-icon>
  </button>

  <a *ngIf="isVerticalLayout$ | async" [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 block" fxLayout="row"
    fxLayoutAlign="start center">
    <img class="w-8 select-none" src="assets/img/demo/logo.svg" />
    <h1 [fxHide]="mobileQuery" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">
      QQME
    </h1>
  </a>

  <div *ngIf="(isVerticalLayout$ | async) && isNavbarInToolbar$ | async" [fxHide]="mobileQuery" class="px-gutter"
    fxFlex="none" fxLayout="row" fxLayoutAlign="start center">
    <vex-navigation-item *ngFor="let item of navigationItems" [item]="item"></vex-navigation-item>
  </div>

  <span fxFlex></span>

  <div class="-mx-1 flex items-center">
    <div class="px-1 hidden md:block">
      <div #searchBoxHost class="relative w-full max-w-md">
        <div class="search-input-container border border-gray-300 rounded-full px-4 flex items-center"
          style="background-color: var(--app-control-soft) !important">
          <input #searchInputRef class="search-input py-3 border-0 outline-none w-full bg-transparent"
            placeholder="Search..." type="search" (focus)="showResults = true" (blur)="hideResults()"
            (input)="onSearchInput($event.target.value)" (paste)="onSearchPaste()" />
          <mat-icon *ngIf="!searchQuery" style="color: var(--app-heading) !important">
            search
          </mat-icon>
        </div>

        <div *ngIf="showResults && searchQuery?.trim()?.length > 0" class="search-dropdown"
          (mousedown)="$event.preventDefault()">
          <ul>
            <ng-container *ngIf="caseMatches?.length > 0">
              <li class="search-section-title">Case Number</li>
              <li *ngFor="let encounter of caseMatches">
                <mat-icon class="qqmeIcon">tag</mat-icon>

                <span *ngIf="
                    encounter &&
                    encounter.history_status !== null &&
                    encounter.status !== null
                  ">
                  <ng-container *ngIf="
                      encounter.encounterId as encounterData;
                      else noEncounter
                    ">
                    <ng-container *ngIf="getFirstAvailableSubComponent() as subComponent">
                      <span class="cursor-pointer" [routerLink]="[subComponent.route]"
                        [queryParams]="{ id: caseEncounterQueryId(encounter) }">
                        {{ encounter?.encounterId?.caseNumber }}:
                        {{ encounter?.encounterId?.fullName }}
                      </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #noEncounter>
                    <span class="no-encounter-message">No encounter</span>
                  </ng-template>
                </span>

                <span *ngIf="
                    encounter &&
                    encounter.history_status == null &&
                    encounter.status == null &&
                    encounter.deposition_status == null
                  ">
                  <ng-container *ngIf="
                      encounter.encounterId as encounterData;
                      else noEncounter
                    ">
                    <ng-container *ngIf="
                        getFirstAvailablePQMESSubComponent() as subComponent
                      ">
                      <span class="cursor-pointer" [routerLink]="[subComponent.route]"
                        [queryParams]="{ id: caseEncounterQueryId(encounter) }">
                        {{ encounter?.encounterId?.caseNumber }}:
                        {{ encounter?.encounterId?.fullName }}
                      </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #noEncounter>
                    <span class="no-encounter-message">No encounter</span>
                  </ng-template>
                </span>

                <span *ngIf="encounter && encounter.deposition_status !== null">
                  <ng-container *ngIf="
                      encounter.encounterId as encounterData;
                      else noEncounter
                    ">
                    <ng-container *ngIf="
                        getDepositionAvailableSubComponent() as subComponent
                      ">
                      <span class="cursor-pointer" [routerLink]="[subComponent.route]"
                        [queryParams]="{ id: caseEncounterQueryId(encounter) }">
                        {{ encounter?.encounterId?.caseNumber }}:
                        {{ encounter?.encounterId?.fullName }}
                      </span>
                    </ng-container>
                  </ng-container>
                  <ng-template #noEncounter>
                    <span class="no-encounter-message">No encounter</span>
                  </ng-template>
                </span>

                <span *ngIf="toolbarCaseSearchNeedsFallback(encounter)">
                  <ng-container *ngIf="encounter.encounterId as encounterData">
                    <ng-container *ngIf="getFirstAvailableSubComponent() as subComponent">
                      <span class="cursor-pointer" [routerLink]="[subComponent.route]"
                        [queryParams]="{ id: caseEncounterQueryId(encounter) }">
                        {{ encounter?.encounterId?.caseNumber }}:
                        {{ encounter?.encounterId?.fullName }}
                      </span>
                    </ng-container>
                  </ng-container>
                </span>
              </li>
            </ng-container>

            <ng-container *ngIf="filteredApplicants?.length > 0">
              <li class="search-section-title">Applicants</li>
              <li *ngFor="let applicant of filteredApplicants" class="applicant-result-item"
                (click)="navigateTo('/reports/patient_profile/' + applicant.applicantID)">
                <!-- Avatar -->
                <div class="applicant-avatar">
                  <mat-icon>person</mat-icon>
                </div>

                <!-- Info block -->
                <div class="applicant-info">
                  <!-- Row 1: Name + ID + DOB -->
                  <div class="applicant-primary">
                    <span class="applicant-name">
                      {{ applicant.applicantName }}
                      {{ applicant.applicantMiddleName }}
                      {{ applicant.applicantLastName }}
                    </span>
                    <span class="applicant-id">[{{ applicant.applicantID }}]</span>
                    <ng-container *ngIf="applicant.dob">
                      <span class="applicant-dot">·</span>
                      <span class="applicant-dob">DOB: {{ applicant.dob | date: 'MM/dd/yyyy' : 'UTC' }}</span>
                    </ng-container>
                  </div>

                  <!-- Row 2: Physicians -->
                  <div class="applicant-secondary" *ngIf="applicant.physicians?.length > 0">
                    <mat-icon [icIcon]="icStethoscope" class="physician-icon"></mat-icon>
                    <span class="physician-name">{{ applicant.physicians.slice(0, 3).join(', ') }}</span>
                    <ng-container *ngIf="applicant.physicians.length > 3">
                      <span class="physician-more"
                        [matTooltip]="'\u25cf ' + applicant.physicians.slice(3).join('\n\u25cf ')"
                        matTooltipClass="physician-tooltip" matTooltipPosition="right">
                        +{{ applicant.physicians.length - 3 }} more
                      </span>
                    </ng-container>
                  </div>
                </div>
              </li>
            </ng-container>

            <li *ngIf="isLoading" class="text-gray-500 text-center p-2">
              Searching...
            </li>

            <li *ngIf="showNoResults" class="text-gray-500 text-center p-2">
              No results found
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="px-1" *ngIf="!notificationsDisabled">
      <vex-toolbar-notifications></vex-toolbar-notifications>
    </div>

    <div class="px-1">
      <button mat-icon-button type="button" matTooltip="Google Account" aria-label="Google Account"
        (click)="redirectTo('https://drive.google.com')">
        <img src="/assets/GDL.png" class="w-6" alt="Google Account" />
      </button>
    </div>

    <div class="px-1">
      <button mat-icon-button type="button" matTooltip="Gmail" aria-label="Gmail"
        (click)="redirectTo('https://mail.google.com')">
        <img src="/assets/new.png" class="w-6" alt="Gmail" />
      </button>
    </div>

    <div class="px-1">
      <button mat-icon-button type="button" matTooltip="Google Calendar" aria-label="Calendar"
        (click)="redirectTo('https://calendar.google.com')">
        <img src="/assets/new (1).png" class="w-6" alt="Google Calendar" />
      </button>
    </div>

    <div class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>
  </div>
</div>

<vex-navigation *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
  [fxHide]="mobileQuery"></vex-navigation>